import { stdObject } from "./types/stdObject";

export const brandsHeaders: stdObject[] = [
  { code: "IMGMAR", label: "p.image" },
  { code: "NOMMAR", label: "p.name" },
];
